import { ascendingSort } from "@hellocarbo/lasagne/utils";
import { useTranslation } from "react-i18next";

import type { CurrentStep } from "@/types";
import { getActionData } from "@/utils/onboardingActions";

import Action from "./Action";

interface ActionsProps {
  currentStep: CurrentStep;
  trackingCampaignId: number | null;
  scoreId: number | null;
  reviewId: number | null;
}

const Actions = ({
  currentStep,
  trackingCampaignId,
  scoreId,
  reviewId,
}: ActionsProps) => {
  const { t } = useTranslation("onboarding");

  const actions = currentStep?.actions || [];

  const sortedActions = actions.sort((a, b) => ascendingSort(a.rank, b.rank));

  return (
    <ul className="gap-y-xs flex flex-col">
      {sortedActions.map((action) => {
        const { icon, url, isExternal } = getActionData({
          actionId: action.key,
          trackingCampaignId,
          scoreId,
          reviewId,
        });

        return (
          <Action
            key={action.key}
            Icon={icon}
            title={t(`actions.actions_list.${action.key}.title`)}
            actionKey={action.key}
            isSkippable={action.is_skippable}
            unavailableReason={t(
              `actions.actions_list.${action.key}.unavailable_reason`
            )}
            status={action.status}
            href={url}
            isExternal={isExternal}
          />
        );
      })}
    </ul>
  );
};

export default Actions;
